import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NetworkConnectivityBanner = () => {
    const [isOffline, setIsOffline] = useState(false);

    useEffect(() => {
        // Check if the browser supports the Network Information API
        if (!('connection' in navigator)) {
            return;
        }

        const connection = (navigator as any).connection;
        
        // Add event listener for connection changes
        const updateConnectionStatus = () => {
            setIsOffline(connection.downlink <= 0.05);
        };

        updateConnectionStatus();
        
        connection.addEventListener('change', updateConnectionStatus);
        
        // Clean up event listener
        return () => {
            connection.removeEventListener('change', updateConnectionStatus);
        };
    }, []);

    if (!isOffline) return null;

    return (
        <div className="w-full bg-red-600 text-white py-2 px-4 text-center font-semibold absolute top-0 left-0 z-[60]">
            <FontAwesomeIcon icon="wifi" className="mr-2" />
            Unstable network connection detected. Some features may not work correctly.
        </div>
    );
};

export default NetworkConnectivityBanner;
